import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import routes from '../../config/routes';

import useAuth from '../../hooks/useAuth';
import Login from '../../pages/Login';
import Layout from '../Layout';

export default function Routes() {
  const { isAuthenticated } = useAuth();

  return (
    <Switch>
      {/* Login direto */}
      <Route path="/login/direto/:id_entidade/:id_usuario/:st_urlacesso">
        <Login />
      </Route>

      {/* Redirecionar para a HOME caso JÁ esteja logado */}
      <Route path="/login">{!isAuthenticated ? <Login /> : <Redirect to="/" />}</Route>

      {/* Redirecionar para O LOGIN caso NÃO esteja logado */}
      {!isAuthenticated && (
        <Route path="*">
          <Redirect to="/login" />
        </Route>
      )}

      {/* Rotas disponíves com usuário LOGADO */}
      {isAuthenticated && (
        <Layout>
          {routes.map((route) => (
            <Route key={route.path} {...route}>
              {route.screen}
            </Route>
          ))}
        </Layout>
      )}
    </Switch>
  );
}
